<mat-icon *ngIf="type === PersonType.NATURAL_PERSON" [inline]="inline">person</mat-icon>
<mat-icon *ngIf="type === PersonType.MORAL_PERSON" [inline]="inline">corporate_fare</mat-icon>
<mat-icon *ngIf="type === undefined" [inline]="inline">help_outline</mat-icon>
<mat-icon *ngIf="type === null" [inline]="inline">help_outline</mat-icon>
